const registry = new Map();

/**
 * Register a provider class by name.
 * Called from each provider module's top-level scope.
 */
export function registerProvider(name, ProviderClass) {
  registry.set(name, ProviderClass);
}

/**
 * Provider registry for looking up providers by name.
 */
export const providerRegistry = {
  get(name) {
    return registry.get(name);
  },
  has(name) {
    return registry.has(name);
  },
  names() {
    return Array.from(registry.keys());
  },
};
